import { Box } from '@mui/material';
import { keyframes } from '@mui/material/styles';
import type { ReactNode } from 'react';

const sectionEnter = keyframes`
	from {
		opacity: 0;
		transform: translate3d(0, 8px, 0);
	}
	to {
		opacity: 1;
		transform: translate3d(0, 0, 0);
	}
`;

type Props = {
	children: ReactNode;
	/** Stagger index (0-based); ~100ms between siblings per make-interfaces-feel-better. */
	staggerIndex: number;
};

/**
 * Split enter: each block fades up with delay. Respects `prefers-reduced-motion`.
 */
export function DetailsAnimatedSection({ children, staggerIndex }: Props) {
	return (
		<Box
			sx={{
				'@media (prefers-reduced-motion: reduce)': {
					animation: 'none',
				},
				'@media (prefers-reduced-motion: no-preference)': {
					animation: `${sectionEnter} 0.4s cubic-bezier(0.2, 0, 0, 1) both`,
					animationDelay: `${staggerIndex * 0.08}s`,
				},
			}}
		>
			{children}
		</Box>
	);
}
